export default "__VITE_ASSET__DGnbYJJU__"